import { Stack } from '@mui/material';

import { FlowDefinition } from 'vivaa-api';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockRadioGroupField } from '../../../ConfigFields/RadioGroupField';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

const { GetExternalDocumentPacketOption } = FlowDefinition;
type GetExternalDocumentPacketOption = FlowDefinition.GetExternalDocumentPacketOption;

export function ExternalDocumentPacketsFormFields() {
  const { value: externalDocumentPacketOption } =
    useSelectedNodeField<GetExternalDocumentPacketOption>('config.getExternalDocumentPacketOption');
  return (
    <>
      <Stack gap={2}>
        <BlockRadioGroupField
          fieldName="config.getExternalDocumentPacketOption"
          label="Options"
          row
          defaultValue={GetExternalDocumentPacketOption.GetOneById}
          options={[
            { label: 'Get one by ID', value: GetExternalDocumentPacketOption.GetOneById },
            { label: 'Find by file name', value: GetExternalDocumentPacketOption.FindByFileName },
          ]}
        />
        {externalDocumentPacketOption === GetExternalDocumentPacketOption.FindByFileName ? (
          <BlockValueTemplateField
            fieldName="config.fileName"
            label="File Name"
            required
            helperText="File name to match (case-insensitive, extensions ignored). e.g. `TestDocument` or `{{start.data.fileName}}`"
            placeholder="e.g. {{start.data.fileName}}"
          />
        ) : (
          <BlockValueTemplateField
            fieldName="config.externalDocumentPacketId"
            label="External Document Packet ID"
            required
            helperText="Enter the reference to the EDP ID. e.g. `{{start.data.externalDocumentPacketId}}`"
            placeholder="e.g. {{start.data.externalDocumentPacketId}}"
          />
        )}
      </Stack>
    </>
  );
}
